export default __webpack_public_path__ + "static/media/logo-dark.e804529a.png";